import Sections from '../components/Sections';

function HomePage() {
  return <Sections />;
}

export default HomePage;
